export function createCsvFile({
  headers,
  rows,
}: {
  headers: string[];
  rows: string[][];
}) {
  const escapeCsvValue = (value: string) => {
    return `"${value.replace(/"/g, '""')}"`;
  };

  const csvContent = [headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\r\n');

  return new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
}
